<template>
  <div>
    <BlogPost :blog-post="blogPost"></BlogPost>
    <FooterJoin
      title="Want to **contribute?**"
      text="Write a post in collaboration with us and get featured on the Baserow Blog."
      :buttons="[
        {
          id: '1',
          value: {
            type: 'primary',
            text: 'Submit your post',
            url_or_path: '/blog/how-to-contribute-to-the-baserow-blog',
          },
        },
      ]"
    ></FooterJoin>
  </div>
</template>
<script>
import BlogPost from '@saas/components/blog/BlogPost'
import FooterJoin from '@saas/components/footer/FooterJoin'
import BlogService from '@saas/services/blog'
import moment from '@baserow/modules/core/moment'
import { getBaserowDefaultOpenGraphImage } from '@saas/utils'

export default {
  name: 'BlogPage',
  components: { BlogPost, FooterJoin },
  layout: 'saas',
  async asyncData({ params, error, app }) {
    const slug = params.blogPostSlug
    if (slug == null) {
      return error({
        statusCode: 404,
        message: 'A blog post must be selected.',
      })
    }
    try {
      const blogService = BlogService(app.$client)
      const blogPostData = await blogService.get(slug)
      return {
        blogPost: blogPostData.data,
      }
    } catch (e) {
      return error({
        statusCode: 404,
        message: 'Blog post could not be found.',
      })
    }
  },
  head() {
    return {
      title: this.blogPost.title,
      meta: [
        {
          name: 'description',
          content: this.blogPost.meta_description,
        },
        {
          property: 'og:locale',
          content: 'en_us',
        },
        {
          property: 'og:site_name',
          content: 'Baserow',
        },
        {
          property: 'og:title',
          content: this.blogPost.title,
        },
        {
          property: 'og:url',
          content: `${this.$config.PUBLIC_WEB_FRONTEND_URL}${this.$nuxt.$route.path}`,
        },
        {
          property: 'og:type',
          content: 'article',
        },
        {
          property: 'og:description',
          content: this.blogPost.meta_description,
        },
        {
          property: 'og:image',
          content:
            this.blogPost.og_image ||
            getBaserowDefaultOpenGraphImage(this.$config),
        },
      ],
    }
  },
  methods: {
    formatBlogPostDate(date) {
      return moment(date).format('MMMM D, YYYY')
    },
  },
}
</script>
